if (!customElements.get('connected-products')) {
  class ConnectedProducts extends HTMLElement {
    constructor() {
      super();
      this.el = this;

      this.mainProductHandle = this.el.dataset.mainProductHandle;
      this.useJavascript = this.el.dataset.useJavascript == 'true';

      if (this.useJavascript) {
        this.getConnectedProductsHtml(this.mainProductHandle);
      }
    }

    initFlickitySwatches() {
      const sliders = document.querySelectorAll('.product-grid-item__swatches-slider');
      if (!sliders.length) return;

      const Flickity = window.themeVendor?.Flickity;

      sliders.forEach((slider) => {
        const items = slider.querySelectorAll('.product-grid-item__swatches-slider__item');

        if (items.length > 5) {
          const sl = new Flickity(slider, {
            wrapAround: false,
            pageDots: false,
            prevNextButtons: false,
            cellAlign: 'left'
          });
        }
      });
    }

    async getConnectedProductsHtml(handle) {
      const connectedProductHref = `${window.theme?.routes?.root}products/${handle}?view=connected-products`;
      document.dispatchEvent(new CustomEvent('connected-products-fetching', { bubbles: true }));

      try {
        const resp = await fetch(connectedProductHref, {
          headers: {
            'Content-Type': 'application/json',
          }
        });

        if (!resp.ok) {
          throw new Error(`Failed to fetch connected products. Status: ${resp.status}`);
        }

        const responseText = await resp.text();
        const respDOM = new DOMParser().parseFromString(responseText, 'text/html');
        const fetchedConnectedProducts = respDOM.querySelector('connected-products').cloneNode(true);

        if (this.el) {
          this.el.innerHTML = fetchedConnectedProducts.innerHTML;
          this.initFlickitySwatches();
          this.initHoverSwitching();
        }

      } catch (error) {
        console.error(`Error fetching connected products: ${error.message}`);
      }

    }

    initHoverSwitching() {
      const connectedProductItems = this.querySelectorAll('.product-grid-item__swatches-slider__item');
      connectedProductItems?.forEach(connectedProduct => {

        this.cardWrapper = connectedProduct.closest('.product-grid-item');
        this.cardImages = this.cardWrapper?.querySelectorAll('figure.product__media img');
        this.mainProdSrcSetAll = Array.from(this.cardImages || []).map(image => image.getAttribute('srcset'));
        this.sizesEl = this.cardWrapper?.querySelector('.product-grid-items__sizes');
        this.mainProdSize = this.sizesEl ? this.sizesEl.innerHTML : null;

        connectedProduct.addEventListener('mouseenter', this.setProductCardToConnectedProduct.bind(this, connectedProduct));
        connectedProduct.addEventListener('mouseleave', this.unsetProductCardToConnectedProduct.bind(this));
      });
    }

    setProductCardToConnectedProduct(connectedProduct) {
      const newImage = connectedProduct.dataset?.image;
      if (newImage) {
        this.cardImages?.forEach(image => {
          image.setAttribute('srcset', newImage);
        });
      }

      const connectedSizes = connectedProduct.dataset?.sizes;

      if (connectedSizes && this.mainProdSize && this.sizesEl) {
        this.sizesEl.innerHTML = connectedSizes;
      }
    }

    unsetProductCardToConnectedProduct() {
      if (this.mainProdSrcSetAll && this.mainProdSrcSetAll.length && this.mainProdSrcSetAll.length === this.cardImages.length) {
        this.cardImages?.forEach((image, index) => {
          image.setAttribute('srcset', this.mainProdSrcSetAll[index]);
        });
      }

      if (this.mainProdSize && this.sizesEl) {
        this.sizesEl.innerHTML = this.mainProdSize;
      }
    }
  }



  customElements.define('connected-products', ConnectedProducts);
}